import type {
  Permission,
  ScopeKind,
} from "../../../../../shared/rbac/permissions";
import { SCOPE_KINDS } from "../../../../../shared/rbac/permissions";
import {
  BUILTIN_ROLES,
  type BuiltinRoleId,
} from "../../../../../shared/rbac/roles";

export type RoleRow = {
  id: string;
  name: string;
  scope: ScopeKind;
  permissions: readonly Permission[];
  isBuiltin: boolean;
  grantsCount: number;
  createdAt: number;
};

type CustomRole = {
  id: string;
  name: string;
  scopeKind: string;
  rolePermissions: readonly { permission: string }[];
  createdAt?: number;
};

export function buildRoleRows(
  customRoles: readonly CustomRole[],
  grantCounts: Map<string, number>
): RoleRow[] {
  const rows: RoleRow[] = [];
  for (const [id, role] of Object.entries(BUILTIN_ROLES) as [
    BuiltinRoleId,
    (typeof BUILTIN_ROLES)[BuiltinRoleId],
  ][]) {
    if (!role.userFacing) continue;
    rows.push({
      id,
      name: role.label,
      scope: role.scopeKind,
      permissions: role.permissions,
      isBuiltin: true,
      grantsCount: grantCounts.get(id) ?? 0,
      createdAt: 0,
    });
  }
  for (const role of customRoles) {
    rows.push({
      id: role.id,
      name: role.name,
      scope: role.scopeKind as ScopeKind,
      permissions: role.rolePermissions.map(
        (rp) => rp.permission as Permission
      ),
      isBuiltin: false,
      grantsCount: grantCounts.get(role.id) ?? 0,
      createdAt: role.createdAt ?? 0,
    });
  }
  return rows;
}

export function countByScope(
  rows: readonly RoleRow[]
): Record<ScopeKind, number> {
  const counts = Object.fromEntries(SCOPE_KINDS.map((s) => [s, 0])) as Record<
    ScopeKind,
    number
  >;
  for (const row of rows) counts[row.scope] += 1;
  return counts;
}
